"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));

var _reactRatingStarsComponent = _interopRequireDefault(require("react-rating-stars-component"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _emojiRegex = _interopRequireDefault(require("../utils/emojiRegex"));

var _Emoji = _interopRequireDefault(require("../Emoji"));

var _Button = _interopRequireDefault(require("../Button"));

var _Upload = _interopRequireDefault(require("../Upload"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _Menu = _interopRequireDefault(require("../Menu"));

var _AutocompleteItem = _interopRequireDefault(require("../Autocomplete/AutocompleteItem"));

var _Chip = _interopRequireDefault(require("../Chip"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _utils = _interopRequireDefault(require("../utils/utils"));

var _cursor = _interopRequireDefault(require("../utils/cursor"));

var _forwardRef = _interopRequireDefault(require("../HOC/forwardRef"));

var _SendForm = _interopRequireDefault(require("./SendForm.style"));

var _index = require("../index");

var _dec, _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

const ForwardTextField = (0, _forwardRef.default)(_TextField.default);
let SendForm = (_dec = (0, _reactJss.default)(_SendForm.default), _dec(_class = (0, _reactClickOutside.default)(_class = class SendForm extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showUsers: false,
      findUserMode: false,
      searchQuery: null,
      userList: null,
      focus: false,
      activeUserItem: 0
    };
    this.selectUser = this.selectUser.bind(this);
    this.hideUsers = this.hideUsers.bind(this);
    this.showUsers = this.showUsers.bind(this);
    this.mouseMoveUsers = this.mouseMoveUsers.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this._saveCursorPosition = this._saveCursorPosition.bind(this);
    this.selectEmoji = this.selectEmoji.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.refEdit = props.forwardRef || _react.default.createRef();
    this.refQuoteText = _react.default.createRef(); // начальная позиция курсора

    this.cursorPosition = 0;
    this.portalEl = document.createElement('div');
    this.portalEl.id = `${props.id}_filePreview`;
  }

  componentDidMount() {
    this._isMounted = true;
    this.controls.parentNode.insertBefore(this.portalEl, this.controls);
    this.messageFormatting();
    this.optimizeQuoteSize();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value.quote !== this.props.value.quote) {
      this.optimizeQuoteSize();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  } // Сохранить текущую позицию курсора


  _saveCursorPosition() {
    const pos = _cursor.default.getCaretPosition(this.refEdit.current);

    if (pos !== -1) {
      this.cursorPosition = pos;
    }
  } // Установить курсор в заданую позицию


  _setCursor(position) {
    setTimeout(() => {
      this.sendForm.click();
      this.refEdit.current.focus();

      if (position === 'end') {
        _cursor.default.moveCursorToEnd(this.refEdit.current);

        this._saveCursorPosition();
      } else {
        this.cursorPosition = position;

        _cursor.default.moveCursorToPosition(this.refEdit.current, this.cursorPosition);
      }
    }, 0);
  } // Добавляем/убираем флаг для свертывания + кнопки Show more в зависимости от размера цитаты


  optimizeQuoteSize() {
    const {
      showMore
    } = this.state;
    const maxQuoteHeight = 3 * 22;
    if (!this.refQuoteText.current) return;
    const {
      height
    } = this.refQuoteText.current.getBoundingClientRect();

    if (height > maxQuoteHeight && !showMore) {
      this.setState({
        showMore: 'hide'
      });
    } else if (height <= maxQuoteHeight && showMore) {
      this.setState({
        showMore: null
      });
    }
  } // Форматирование комментария


  messageFormatting() {
    const {
      value
    } = this.props;
    const regBr = new RegExp('<br>', 'gi');
    const regSpan = new RegExp('\\<span.*?\\>(.*?)\\<\\/span\\>', 'g');
    const regSpan1 = new RegExp('\\[span.*?\\](.*?)\\[\\/span\\]', 'g');
    const sourceMessage = value.message.replace(regBr, '\n').replace(regSpan, '$1').replace(regSpan1, '$1');
    const {
      message,
      users
    } = this.highlightAttachments(sourceMessage);

    if (value.message !== message) {
      this.handleChange([{
        id: 'message',
        value: message,
        error: false
      }, {
        id: 'users',
        value: users,
        error: false
      }]);

      this._setCursor('end');
    }
  } // Обработка клика за пределами компонента


  handleClickOutside() {
    this.setState({
      findUserMode: false,
      focus: false
    });
    this.hideUsers();
  } // Обработчик при отправке формы


  handleSubmit() {
    const {
      id,
      value,
      error,
      onSubmit
    } = this.props;
    const {
      showUsers
    } = this.state;
    if (showUsers) return;
    const formatValue = this.formatAndCheck(value);
    onSubmit({
      id,
      value: formatValue,
      error
    });
  } // Format values on submit


  formatAndCheck(value) {
    return _objectSpread(_objectSpread({}, value), {}, {
      message: _utils.default.brToN(value.message),
      users: _utils.default.uniqArrayOfObjects(value.users || [], 'id'),
      sign: value.sign,
      rating: value.rating,
      done: value.done,
      reject: value.reject
    });
  } // Handle change message and files


  handleChange(e) {
    e = Array.isArray(e) ? e : [e];
    const {
      id,
      value,
      onChange
    } = this.props;

    const newValue = _objectSpread({}, value);

    let error = false;
    e.forEach(el => {
      newValue[el.id] = el.value;
      error = error || el.error;
    });
    onChange({
      id,
      value: newValue,
      error
    });
  }

  handleKeyDown(e) {
    const {
      onKeyDown,
      type
    } = this.props;
    const {
      showUsers
    } = this.state;
    const metaKey = e.metaKey || e.ctrlKey;
    const isEnter = e.key === 'Enter';
    const hotKeysManage = ['ArrowDown', 'ArrowUp', 'Enter']; // Если зажат ctrl или command, то делаем перенос строки,
    // иначе по enter отправляем форму

    if (!metaKey && isEnter && !this.state.findUserMode && type === 'chat' || metaKey && isEnter && !this.state.findUserMode && type === 'comment') {
      e.preventDefault();
      this.handleSubmit();
    } else if (metaKey && isEnter && type === 'chat' || isEnter && type === 'comment') {
      _cursor.default.fixLineBreak(e);
    } // Навигация по списку пользователей


    if (showUsers && hotKeysManage.includes(e.key)) {
      this.selectUserUsingButtons(e);
    }

    onKeyDown(e);
  }

  handleKeyUp(e) {
    const {
      onKeyUp
    } = this.props;

    this._saveCursorPosition();

    this.setUsersQueryReq(e.key);
    this.searchUsersQueryReq(e.key);

    if (e.key === ' ' || e.key === 'Backspace') {
      this.messageFormatting();
    }

    onKeyUp(e);
  }

  handleFocus() {
    this.setState({
      focus: true
    });
  } // Устанавливаем поисковый запрос пользователя,
  // если в строке комментария был нажат символ @


  setUsersQueryReq(key) {
    // Игнорируем нажатие на Ctrl, Shift...
    if (key.length > 1) return;
    const {
      findUserMode,
      searchQuery
    } = this.state;
    const {
      options
    } = this.props;
    const users = options.users;

    if (key === '@' && users && users.length) {
      this.showUsers();
      this.setState({
        findUserMode: true
      });
      return;
    }

    if (!findUserMode || !users) return;
    let newSearchQuery = searchQuery ? searchQuery + key : key;
    newSearchQuery = newSearchQuery.toLowerCase();
    const userList = users.filter(user => user.value.toLowerCase().indexOf(newSearchQuery) !== -1);

    if (!userList.length) {
      this.hideUsers();
    } else {
      this.setState({
        searchQuery: newSearchQuery,
        userList
      });
    }
  } // Скролл по списку пользователей


  scrollUserList(item) {
    const container = _reactDom.default.findDOMNode(this.containerUsersList);

    const heightContainer = container.offsetHeight;
    const heightItem = item.offsetHeight;
    const scrollPosition = item.offsetTop < heightContainer - heightItem * 3 ? 0 : item.offsetTop - (heightContainer - heightItem * 3);

    _utils.default.scrollTo(container, scrollPosition, 100);
  } // Поиск в строке комментария поисковой строки пользователя
  // при нажати кнопки Backspace


  searchUsersQueryReq(key) {
    const {
      value,
      options
    } = this.props;
    if (key !== 'Backspace') return;
    const message = value.message;
    const users = options.users || [];
    const clearMessage = this.makeClearMessage(message);
    const leftPart = clearMessage.substring(0, this.cursorPosition);
    const splitLeftPart = leftPart.split('@');
    const query = splitLeftPart[splitLeftPart.length - 1];
    const userList = users.filter(user => user.value.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    const lastDog = leftPart.charAt(leftPart.length - 1);

    if (userList.length && (query.length || lastDog === '@')) {
      this.setState({
        showUsers: true,
        findUserMode: true,
        searchQuery: query,
        userList
      });
    } else {
      this.hideUsers();
    }
  } // Выбрать смайлик


  selectEmoji(emoji) {
    const smile = String.fromCodePoint(parseInt(emoji.unified, 16));
    this.insertAttachment('smile', `${smile} `);
  } // Показать список пользователей


  showUsers() {
    this.setState({
      showUsers: true
    });
    this.refEdit.current.focus();

    _cursor.default.moveCursorToPosition(this.refEdit.current, this.cursorPosition);
  } // Скрыть список пользователей


  hideUsers() {
    this.setState({
      showUsers: false,
      findUserMode: false,
      searchQuery: null,
      activeUserItem: 0
    }); // Задержка обнуления пользователей для плавной анимации скрытия
    // списка пользователей

    setTimeout(() => {
      if (!this._isMounted) return;
      this.setState({
        userList: null
      });
    }, 500);
  } // Движение мышкой по спику пользователей. Сбрасываем индекс активного пользователя


  mouseMoveUsers() {
    this.setState({
      activeUserItem: -1
    });
  } // Выбрать пользователя по навигации стрелочек


  selectUserUsingButtons(e) {
    e.preventDefault();
    const {
      showUsers,
      userList,
      activeUserItem
    } = this.state;
    const {
      options
    } = this.props;
    const users = userList || options.users;
    if (!showUsers) return;
    let newActiveItem = activeUserItem;

    if (e.key === 'ArrowDown' && activeUserItem < users.length - 1) {
      newActiveItem += 1;
    } else if (e.key === 'ArrowUp' && activeUserItem > 0) {
      newActiveItem -= 1;
    }

    if (!users[newActiveItem]) return;
    const item = this[`itemRef${newActiveItem}`];

    if (e.key === 'Enter') {
      this.selectUser({
        value: item.props
      });
      newActiveItem = 0;
    }

    this.setState({
      activeUserItem: newActiveItem
    }, this.scrollUserList(_reactDom.default.findDOMNode(item)));
  } // Выбрать пользователя из списка


  selectUser({
    value: vItem
  }) {
    const userStr = `@${vItem.value} `;
    this.insertAttachment('user', userStr);
  } // Вставить вложение в текст комментария по позиции курсора


  insertAttachment(type, attachment) {
    const {
      value
    } = this.props;
    const clearMessage = this.makeClearMessage(value.message);
    const matchLieBreak = clearMessage.match(/\n/g);
    const lineBreakLen = matchLieBreak ? matchLieBreak.length : 0;
    const cursorPos = this.cursorPosition + lineBreakLen;
    const firstPart = clearMessage.substring(0, cursorPos);
    const lastPart = clearMessage.substring(cursorPos);
    const fix = this.replaceSearchReq(type, firstPart, lastPart);
    const newMessage = `${fix.firstPart}${attachment}${fix.lastPart}`;
    const {
      message,
      users
    } = this.highlightAttachments(newMessage);
    this.handleChange([{
      id: 'message',
      value: message,
      error: false
    }, {
      id: 'users',
      value: users,
      error: false
    }]);

    this._setCursor(`${fix.firstPart}${attachment}`.length - lineBreakLen);
  } // Удалить поисковый запрос пользователя из строки комментария
  // при выборке пользователя из выпадающего списка


  replaceSearchReq(type, firstPart, lastPart) {
    const {
      searchQuery,
      findUserMode
    } = this.state;
    if (type !== 'user' || !findUserMode) return {
      firstPart,
      lastPart
    };
    const lastIndexOf = firstPart.lastIndexOf(`@${searchQuery || ''}`);
    const fixFirstPart = firstPart.substring(0, lastIndexOf);
    return {
      firstPart: fixFirstPart,
      lastPart
    };
  } // Удаляем из строки комментария все html теги.


  makeClearMessage(sourceMessage) {
    const regBr = new RegExp('<br>', 'gi');
    const regSpan = new RegExp('\\<span.*?\\>(.*?)\\<\\/span\\>\\&nbsp\\;', 'g');
    return sourceMessage.replace(regBr, '\n').replace(regSpan, '$1 ');
  } // Парсинг строки комментария, выделяем смайлики и пользователей


  highlightAttachments(sourceMessage) {
    const {
      options
    } = this.props;
    const users = options.users || [];
    let message; // Преобразовываем переносы строк

    const regBr = new RegExp('\n', 'gi'); // eslint-disable-line no-control-regex

    message = sourceMessage.replace(regBr, '<br>'); // Оборачиваем все смайлики в span

    let match;
    const regex = _emojiRegex.default;

    while (match = regex.exec(sourceMessage)) {
      // eslint-disable-line no-cond-assign
      const emoji = match[0];
      message = message.replace(`${emoji} `, `<span class="emoji">${emoji}</span>&nbsp;`);
    } // Оборачиваем упоминания пользователей в span


    const foundUsers = [];
    users.forEach(user => {
      const nick = user.value;
      const copyMessage = message;
      const reg = new RegExp(`\\@${nick}(\\&nbsp\\;|\\s){1,}`, 'gim');
      message = message.replace(reg, `<span class="user">@${nick}</span>&nbsp;`); // Если строка изменилась, то сохраняем пользователя

      if (message !== copyMessage) {
        foundUsers.push(user);
      }
    });
    return {
      message,
      users: foundUsers
    };
  } // Показать попап со списком пользователей


  renderUsers() {
    const {
      options,
      classes
    } = this.props;
    const {
      showUsers,
      userList,
      activeUserItem
    } = this.state;
    if (!options.users) return null;
    const users = userList || options.users;
    const activeItem = users[activeUserItem] ? users[activeUserItem].id : null;
    return /*#__PURE__*/_react.default.createElement(_Menu.default, {
      ref: el => {
        this.containerUsersList = el;
      },
      id: "users",
      className: classes.usersList,
      visibility: showUsers ? 'visible' : 'hidden',
      onClick: this.selectUser,
      onClose: this.hideUsers,
      onMouseMove: this.mouseMoveUsers
    }, users.map((i, index) => /*#__PURE__*/_react.default.createElement(_AutocompleteItem.default, (0, _extends2.default)({
      ref: el => {
        this[`itemRef${index}`] = el;
      },
      key: i.id,
      size: "medium",
      activeItem: activeItem
    }, i))));
  }

  renderSign() {
    const {
      classes
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Chip.default, {
      className: classes.sign,
      label: "Signed",
      type: "rectangular",
      icon: "sign",
      closeClick: () => this.handleChange({
        id: 'sign',
        value: false
      })
    });
  }

  renderDone() {
    const {
      classes
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Chip.default, {
      className: classes.done,
      label: "Done",
      type: "rectangular",
      icon: "check_box",
      closeClick: () => this.handleChange({
        id: 'done',
        value: false
      })
    });
  }

  renderReject() {
    const {
      classes
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Chip.default, {
      className: classes.reject,
      label: "Rejected",
      type: "rectangular",
      icon: "add",
      closeClick: () => this.handleChange({
        id: 'reject',
        value: false
      })
    });
  }

  renderRate(value) {
    const {
      classes
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Chip.default, {
      type: "rectangular",
      className: classes.rating,
      closeClick: () => this.handleChange({
        id: 'rating',
        value: false
      })
    }, /*#__PURE__*/_react.default.createElement(_reactRatingStarsComponent.default, {
      count: 5,
      size: 14,
      half: false,
      value: value,
      color1: '#ACB3BE',
      color2: '#FFA701',
      onChange: value => this.handleChange({
        id: 'rating',
        value
      })
    }));
  }

  renderQuote(text) {
    const {
      classes
    } = this.props;
    const {
      showMore
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.quote
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.controlsIconsItem, 'quotationMark'),
      type: "quote",
      size: "medium"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.quoteWrap
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: this.refQuoteText,
      className: (0, _clsx.default)(classes.quoteText, {
        hidden: showMore === 'hide'
      })
    }, text), showMore ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: classes.quoteShowBtn,
      size: "small",
      type: "text",
      label: showMore === 'hide' ? 'Show more' : 'Show less',
      onClick: () => this.setState({
        showMore: showMore === 'hide' ? 'show' : 'hide'
      })
    }) : null), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.controlsIconsItem, 'quotationCancel'),
      type: "close",
      size: "small",
      onClick: () => this.handleChange({
        id: 'quote',
        value: ''
      })
    }));
  }

  render() {
    const {
      focus
    } = this.state;
    const {
      id,
      classes,
      className,
      visibility,
      placeholder,
      value,
      type,
      contentType,
      sendButtonLabel,
      cancelButtonLabel,
      autoFocus,
      error,
      options,
      onCancel,
      maxFileSize,
      maxFileSizeErrorText,
      onKeyPress,
      onClickForm,
      artifacts
    } = this.props;
    const formClasses = (0, _clsx.default)(className, classes.sendForm, classes[type], {
      focus
    }, {
      error: !!error
    }, {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled'
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: formClasses,
      ref: el => this.sendForm = el
    }, value.quote && value.quote.length ? this.renderQuote(value.quote) : null, /*#__PURE__*/_react.default.createElement(ForwardTextField, {
      ref: this.refEdit,
      id: "message",
      className: classes.input,
      autoFocus: autoFocus,
      visibility: visibility,
      value: value.message,
      placeholder: placeholder,
      onChange: e => this.handleChange(e, 'message'),
      onFocus: this.handleFocus,
      onKeyDown: this.handleKeyDown,
      onKeyPress: onKeyPress,
      onKeyUp: this.handleKeyUp,
      onBlur: this._saveCursorPosition,
      multiline: true,
      multilineType: contentType
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.artifacts
    }, value.sign ? this.renderSign() : null, value.rating && value.rating !== 0 ? this.renderRate(value.rating) : null, value.done ? this.renderDone() : null, value.reject ? this.renderReject() : null, artifacts), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.controls,
      ref: el => this.controls = el
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.controlsIcons
    }, options.users ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: classes.controlsIconsItem,
      type: "dog",
      size: "medium",
      onClick: this.showUsers
    }) : null, options.smiles ? /*#__PURE__*/_react.default.createElement(_Emoji.default, {
      className: classes.controlsIconsItem,
      visibility: visibility,
      size: "medium",
      onChange: ({
        value
      }) => this.selectEmoji(value)
    }) : null, options.files ? /*#__PURE__*/_react.default.createElement(_Upload.default, {
      id: "files",
      visibility: visibility,
      className: classes.controlsIconsItem,
      multiple: options.files.multiple,
      preview: options.files.preview,
      accept: options.files.accept,
      value: value.files,
      portal: this.portalEl,
      maxFileSize: maxFileSize,
      maxFileSizeErrorText: maxFileSizeErrorText,
      onChange: e => this.handleChange(e, 'files')
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: 'attach',
      size: "medium"
    })) : null, options.rating || options.sign || options.done || options.reject || options.form ? /*#__PURE__*/_react.default.createElement("div", {
      className: classes.divider
    }) : null, options.rating ? /*#__PURE__*/_react.default.createElement(_index.Tooltip, {
      value: "Rate"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: classes.controlsIconsItem,
      type: 'star_full',
      size: "medium",
      onClick: () => this.handleChange([{
        id: 'reject',
        value: false
      }, {
        id: 'done',
        value: false
      }, {
        id: 'sign',
        value: false
      }, {
        id: 'rating',
        value: 1
      }])
    })) : null, options.sign ? /*#__PURE__*/_react.default.createElement(_index.Tooltip, {
      value: "Sign"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: classes.controlsIconsItem,
      type: 'sign',
      size: "medium",
      onClick: () => this.handleChange([{
        id: 'reject',
        value: false
      }, {
        id: 'done',
        value: false
      }, {
        id: 'sign',
        value: true
      }, {
        id: 'rating',
        value: 0
      }])
    })) : null, options.done ? /*#__PURE__*/_react.default.createElement(_index.Tooltip, {
      value: "Done"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: classes.controlsIconsItem,
      type: 'check_box',
      size: "medium",
      onClick: () => {
        this.handleChange([{
          id: 'reject',
          value: false
        }, {
          id: 'done',
          value: true
        }, {
          id: 'sign',
          value: false
        }, {
          id: 'rating',
          value: 0
        }]);
      }
    })) : null, options.reject ? /*#__PURE__*/_react.default.createElement(_index.Tooltip, {
      value: "Reject"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.controlsIconsItem, 'reject'),
      type: 'add',
      size: "medium",
      onClick: () => {
        this.handleChange([{
          id: 'reject',
          value: true
        }, {
          id: 'done',
          value: false
        }, {
          id: 'sign',
          value: false
        }, {
          id: 'rating',
          value: 0
        }]);
      }
    })) : null, options.form ? /*#__PURE__*/_react.default.createElement(_index.Tooltip, {
      value: "Script"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.controlsIconsItem, 'form'),
      type: 'form',
      size: "medium",
      onClick: onClickForm
    })) : null), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.controlsBtn
    }, cancelButtonLabel ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      size: "small",
      type: "text",
      label: cancelButtonLabel,
      onClick: () => onCancel({
        id,
        value,
        error
      })
    }) : null, sendButtonLabel ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      size: "small",
      label: sendButtonLabel,
      onClick: this.handleSubmit,
      visibility: !error && (value.message || value.files && value.files.length || value.users && value.users.length || value.rating || value.sign || value.done || value.reject) || artifacts ? 'visible' : 'disabled'
    }) : null)), this.renderUsers());
  }

}) || _class) || _class);
SendForm.defaultProps = {
  visibility: 'visible',
  error: false,
  contentType: 'text',
  value: {
    message: '',
    files: [],
    users: [],
    sign: false,
    done: false,
    reject: false,
    rating: 0,
    quote: ''
  },
  sendButtonLabel: 'Send',
  type: 'chat',
  options: {
    smiles: {},
    files: {
      multiple: true,
      preview: true
    },
    users: [],
    sign: false,
    rating: false,
    done: false,
    reject: false
  },
  onSubmit: () => {},
  onCancel: () => {},
  onChange: () => {},
  onKeyDown: () => {},
  onKeyUp: () => {},
  onKeyPress: () => {}
};
var _default = SendForm;
exports.default = _default;